<template>
  <b-row>
    <b-col md="12">
      <b-card no-body>
        <b-card-body>
          <b-row>
            <b-col>
              <b-input-group>
                <b-form-input
                  v-model="search"
                  placeholder="Müşteri Kartı Ara"
                />
                <b-input-group-append>
                  <b-button
                    v-if="search !== ''"
                    variant="warning"
                    @click="resetSearch"
                  ><FeatherIcon icon="XIcon" /></b-button>
                  <b-button
                    variant="primary"
                    :disabled="search === ''"
                    @click="searchData"
                  ><FeatherIcon icon="SearchIcon" /></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col
              cols="12"
              md="auto"
            >
              <b-button
                to="customers/add"
                variant="primary"
                block
              ><FeatherIcon icon="PlusIcon" />
                Oluştur
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
        <b-table
          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
        >
          <template #cell(ccode)="data">
            {{ data.item.ccode }}
          </template>
          <template #cell(name)="data">
            <b-link :to="'/customers/view/' + data.item.id">
              <div
                v-if="data.item.ccode"
                class="font-weight-bold text-danger font-small-2"
              >
                Müşteri Kodu: {{ data.item.ccode }}
              </div>
              <div class="font-weight-bold text-body">
                {{ data.item.company }}
              </div>
              <small class="text-warning">{{ data.item.name }}</small>
            </b-link>
          </template>
          <template #cell(city)="data">
            {{ data.item.city }}
          </template>
          <template #cell(phone)="data">
            {{ data.item.phone }}
          </template>
          <template #cell(control)="data">
            <b-button
              :to="'/customers/view/' + data.item.id"
              variant="flat-primary"
              class="btn-icon"
              pill
            >
              <FeatherIcon icon="EyeIcon" />
            </b-button>
            <b-button
              :to="'/customers/edit/' + data.item.id"
              variant="flat-warning"
              class="btn-icon"
              pill
            >
              <FeatherIcon icon="EditIcon" />
            </b-button>
          </template>
        </b-table>
        <b-card-footer>
          <b-pagination
            v-model="currentPage"
            :total-rows="dataCount"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BCardFooter,
  BPagination,
  BButton,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BCardBody,
  BLink,
} from 'bootstrap-vue'

export default {
  name: 'Index',
  components: {
    BCardBody,
    BCard,
    BTable,
    BRow,
    BCol,
    BCardFooter,
    BPagination,
    BButton,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BLink,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 25,
      search: '',
      fields: [
        {
          key: 'name',
          label: 'FİRMA ADI',
        },
        {
          key: 'city',
          label: 'ŞEHİR',
          thClass: 'width-50 text-nowrap',
          tdClass: 'width-50 text-nowrap',
        },
        {
          key: 'phone',
          label: 'TELEFON',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          'customers.id AS id',
          'customers.ccode AS ccode',
          'customers.company AS company',
          'customers.name AS name',
          'customers.phone AS phone',
          'cities.title AS city',
        ],
        limit: 25,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['customers/getCustomers']
    },
    dataCount() {
      return this.$store.getters['customers/getCustomersCount']
    },
  },
  watch: {
    currentPage(val) {
      const page = (val - 1) * 25
      this.pagination(page)
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchData() {
      this.dataQuery.or_like = {
        'customers.ccode': this.search,
        'customers.company': this.search,
        'customers.name': this.search,
        'customers.phone': this.search,
      }
      this.getDataList()
    },
    resetSearch() {
      this.dataQuery.or_like = {}
      this.search = ''
      this.getDataList()
    },
    pagination(page) {
      this.dataQuery.start = page
      if (this.dataQuery.start === page) {
        this.getDataList()
      }
    },
    getDataList() {
      this.$store.dispatch('customers/customersList', this.dataQuery)
    },
  },
}
</script>

<style scoped>

</style>
